module.exports = __webpack_public_path__ + "static/fonts/Miller-Text.4bc825a3.woff";